module.exports = __webpack_public_path__ + "img/Fr-Ozoh6.c55a9f28.jpg";